import { Injectable } from "@angular/core";
@Injectable()
export class HelperService {
  constructor() {}

  // Time
  convertUtcToLocalTime(dateStr) {
    dateStr = dateStr.split('/');
    return this.formatDateTimeString(this.formatDateVariabls(dateStr));
  }

  private formatDateVariabls(dateStr: string) {
    var date = new Date(this.formatStringForUtc(dateStr));
    return {
      dateFormatted: this.formatDate(date),
      dateHours: this.getHours(date),
      dateMinutes: this.getMinutes(date)
    };
  }

  private formatStringForUtc(dateStr: string): string {
    return dateStr[0] + '/' + dateStr[1] + '/' + dateStr[2] + ' UTC';
  }

  private formatDateTimeString({ dateFormatted, dateHours, dateMinutes }) {
    return dateFormatted + ' ' + dateHours + ':' + this.lessThenTenFormat(dateMinutes);
  }

  private lessThenTenFormat(dateMinutes: number) {
    return dateMinutes < 10 ? '0' + dateMinutes : dateMinutes;
  }

  private getMinutes(date: Date) {
    return date.getMinutes();
  }

  private getHours(date: Date) {
    return date.getHours();
  }

  private formatDate(date: Date) {
    return date.toLocaleDateString();
  }
}
